import React, { useEffect, useState, useCallback } from "react";
import Navbar from "./Navbar";
import "./Feedbacktemplatemaster.css";
import toast from "react-hot-toast";
import authStore from "../services/authStore";
import { jwtDecode } from "jwt-decode";
export default function Feedbacktemplatemaster() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const [robotList, setRobotList] = useState([]);
  const [selectedRobot, setSelectedRobot] = useState("");

  const [questionList, setQuestionList] = useState([]);
  const [loadingQuestions, setLoadingQuestions] = useState(false);

  // Helper function to get auth headers
  const getAuthHeaders = useCallback(() => {
    const token = authStore.getToken();
    return {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };
  }, []);

  // Helper to get current user
  const getCurrentUser = useCallback(() => {
    const token = authStore.getToken();

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      return decoded.user_id || decoded.userId || decoded.id;
    } catch (err) {
      console.error("Token decode error:", err);
      return null;
    }
  }, []);

  useEffect(() => {
    const loadRobots = async () => {
      try {
        // ✅ Pass status parameter in API
        const url = `${API_BASE_URL}/robotmaster/GetRobotList?status=Active`;

        const response = await fetch(url, {
          headers: getAuthHeaders(),
        });

        if (!response.ok) throw new Error("Failed to fetch robots");

        const data = await response.json();

        if (Array.isArray(data?.data)) {
          setRobotList(data.data);
        } else if (Array.isArray(data)) {
          setRobotList(data);
        } else {
          setRobotList([]);
        }
      } catch (err) {
        console.error("Robot Load Error:", err.message);
        toast.error("Failed to load robots");
        setRobotList([]);
      }
    };

    loadRobots();
  }, [API_BASE_URL, getAuthHeaders]);
  useEffect(() => {
    if (!selectedRobot) {
      setQuestionList([]);
      return;
    }

    const loadQuestions = async () => {
      setLoadingQuestions(true);

      try {
        const url = `${API_BASE_URL}/feedbackquestiontemplate/GetQuestionsByRobot/${selectedRobot}`;

        const response = await fetch(url, {
          headers: getAuthHeaders(),
        });

        if (!response.ok) throw new Error("Failed to fetch questions");

        const data = await response.json();

        let questions = [];

        if (Array.isArray(data)) {
          questions = data;
        } else if (data && Array.isArray(data.questions)) {
          questions = data.questions;
        } else if (data && Array.isArray(data.data)) {
          questions = data.data;
        }

        const formatted = questions.map((q) => ({
          QUESTION_ID: q.id ?? q.QUESTION_ID ?? 0,
          ROBOTID: q.robot_id ?? q.ROBOTID ?? selectedRobot,
          QUESTION_TEXT: q.question ?? q.QUESTION_TEXT ?? q.question_text ?? "",
          QUESTION_TYPE: q.questiontype ?? q.QUESTION_TYPE ?? "Rating",
          STATUS:
            (q.status || "").toUpperCase() === "ACTIVE" ? "ACTIVE" : "INACTIVE",
        }));

        setQuestionList(formatted);
      } catch (err) {
        console.error("Question Load Error:", err.message);
        toast.error("Failed to load questions");
        setQuestionList([]);
      } finally {
        setLoadingQuestions(false);
      }
    };

    loadQuestions();
  }, [selectedRobot]); // ✅ FIXED

  const handleAddQuestionRow = useCallback(() => {
    const newRow = {
      QUESTION_ID: null,
      QUESTION_TEXT: "",
      QUESTION_TYPE: "Rating",
      STATUS: "ACTIVE",
    };

    setQuestionList((prev) => [...prev, newRow]);
  }, []);

  // ✅ EDIT HANDLERS
  const handleQuestionChange = useCallback((index, value) => {
    setQuestionList((prev) => {
      const updated = [...prev];
      updated[index].QUESTION_TEXT = value;
      return updated;
    });
  }, []);

  const handleTypeChange = useCallback((index, value) => {
    setQuestionList((prev) => {
      const updated = [...prev];
      updated[index].QUESTION_TYPE = value;
      return updated;
    });
  }, []);

  const handleStatusToggleQuestion = useCallback(
    (index) => {
      setQuestionList((prev) => {
        const updated = [...prev];
        const questionId = updated[index].QUESTION_ID;

        if (questionId) {
          const newStatus =
            updated[index].STATUS === "ACTIVE" ? "Inactive" : "Active";
          const currentUser = getCurrentUser();
          const url = `${API_BASE_URL}/feedbackquestiontemplate/UpdateQuestionStatus/${questionId}?status=${newStatus}&createdby=${currentUser}`;

          fetch(url, {
            method: "PUT",
            headers: getAuthHeaders(),
          })
            .then((res) => {
              if (!res.ok) throw new Error("Failed to update status");
              return res.json();
            })
            .then(() => {
              setQuestionList((current) => {
                const newList = [...current];
                newList[index].STATUS =
                  newStatus === "Active" ? "ACTIVE" : "INACTIVE";
                return newList;
              });
              toast.success("Status updated successfully ✅");
            })
            .catch((err) => {
              console.error("Status Update Error:", err.message);
              toast.error("Failed to update status ❌");
            });
        } else {
          // For new unsaved questions, just update locally
          updated[index].STATUS =
            updated[index].STATUS === "ACTIVE" ? "INACTIVE" : "ACTIVE";
        }

        return updated;
      });
    },
    [API_BASE_URL, getAuthHeaders, getCurrentUser],
  );

  // ✅ DELETE ROW
  const handleDeleteRow = useCallback((index) => {
    setQuestionList((prev) => {
      const updated = [...prev];
      updated.splice(index, 1);
      return updated;
    });
  }, []);

  // ✅ SAVE ALL QUESTIONS
  const handleSaveQuestions = useCallback(() => {
    if (!selectedRobot) {
      toast.warning("Please select a robot first");
      return;
    }

    const validQuestions = questionList.filter(
      (q) => q.QUESTION_TEXT && q.QUESTION_TEXT.trim() !== "",
    );

    if (validQuestions.length === 0) {
      toast.warning("Add at least one question");
      return;
    }

    // Prepare payload according to API specification
    const payload = {
      robot_id: Number(selectedRobot),
      createdby: getCurrentUser(),
      questions: validQuestions.map((q) => ({
        id: q.QUESTION_ID ?? 0,
        question: q.QUESTION_TEXT,
        questiontype: q.QUESTION_TYPE,
        status: q.STATUS === "ACTIVE" ? "Active" : "Inactive",
      })),
    };

    console.log("FINAL PAYLOAD ✅", payload);

    const url = `${API_BASE_URL}/feedbackquestiontemplate/AddOrUpdateQuestions`;

    fetch(url, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    })
      .then((res) => {
        if (!res.ok) throw new Error("Save failed");
        return res.json();
      })
      .then(() => {
        toast.success("Questions saved successfully ✅");

        // Refresh questions list after save
        const refreshUrl = `${API_BASE_URL}/feedbackquestiontemplate/GetQuestionsByRobot/${selectedRobot}`;
        return fetch(refreshUrl, {
          headers: getAuthHeaders(),
        });
      })
      .then((res) => {
        if (res.ok) return res.json();
        throw new Error("Failed to refresh questions");
      })
      .then((data) => {
        let questions = [];
        if (Array.isArray(data)) {
          questions = data;
        } else if (data && Array.isArray(data.questions)) {
          questions = data.questions;
        } else if (data && Array.isArray(data.data)) {
          questions = data.data;
        }

        const formatted = questions.map((q) => ({
          QUESTION_ID: q.id || q.QUESTION_ID || null,
          ROBOTID: q.robot_id || selectedRobot,
          QUESTION_TEXT: q.question || q.QUESTION_TEXT || "",
          QUESTION_TYPE: q.questiontype || q.QUESTION_TYPE || "Rating",
          STATUS:
            q.status === "Active" || q.status === "ACTIVE"
              ? "ACTIVE"
              : "INACTIVE",
        }));
        setQuestionList(formatted);
      })
      .catch((err) => {
        console.error("Save Error:", err.message);
        toast.error("Failed to save questions ❌");
      });
  }, [
    selectedRobot,
    questionList,
    getCurrentUser,
    API_BASE_URL,
    getAuthHeaders,
  ]);

  const handlePasteQuestions = useCallback((e, rowIndex) => {
    const pastedText = e.clipboardData.getData("text");

    // If not multi-row → normal paste
    if (!pastedText.includes("\n") && !pastedText.includes("\t")) return;

    e.preventDefault(); // Stop default paste

    const rows = pastedText
      .split(/\r?\n/)
      .map((row) => row.split("\t"))
      .map((cols) => cols.map((c) => c.trim()))
      .filter((cols) => cols[0]);

    if (rows.length === 0) return;

    setQuestionList((prev) => {
      const updated = [...prev];

      // FIRST ROW → goes into current row
      updated[rowIndex] = {
        ...updated[rowIndex],
        QUESTION_TEXT: rows[0][0] || "",
        QUESTION_TYPE: rows[0][1] || "Rating",
        STATUS:
          rows[0][2] === "Active" || rows[0][2] === "ACTIVE"
            ? "ACTIVE"
            : "INACTIVE",
      };

      // REMAINING ROWS → create new rows
      const extraRows = rows.slice(1).map((cols) => ({
        QUESTION_ID: null,
        QUESTION_TEXT: cols[0] || "",
        QUESTION_TYPE: cols[1] || "Rating",
        STATUS:
          cols[2] === "Active" || cols[2] === "ACTIVE" ? "ACTIVE" : "INACTIVE",
      }));

      return [
        ...updated.slice(0, rowIndex + 1),
        ...extraRows,
        ...updated.slice(rowIndex + 1),
      ];
    });
  }, []);

  return (
    <>
      <Navbar />

      <div className="Pagename">
        <div>Feedback Template Master</div>
      </div>

      <div className="Secondbar">
        <label>Select Robot</label>

        <select
          value={selectedRobot}
          onChange={(e) => setSelectedRobot(e.target.value)}
        >
          <option value="">Select Robot</option>

          {Array.isArray(robotList) &&
            robotList.map((robot) => (
              <option key={robot.id || robot.ID} value={robot.id || robot.ID}>
                {robot.robotname || robot.name || robot.NAME}
              </option>
            ))}
        </select>
      </div>

      {/* TABLE */}
      {selectedRobot && (
        <div className="table-container">
          <table className="robot-table">
            <thead>
              <tr>
                <td>Question</td>
                <td>Type</td>
                <td>Status</td>
                <td>Action</td>
              </tr>
            </thead>

            <tbody>
              {loadingQuestions ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    Loading questions...
                  </td>
                </tr>
              ) : !Array.isArray(questionList) || questionList.length === 0 ? (
                <tr>
                  <td colSpan="4" style={{ textAlign: "center" }}>
                    No questions found
                  </td>
                </tr>
              ) : (
                questionList.map((item, index) => (
                  <tr key={index}>
                    {/* QUESTION */}
                    <td>
                      <input
                        type="text"
                        value={item.QUESTION_TEXT || ""}
                        onChange={(e) =>
                          handleQuestionChange(index, e.target.value)
                        }
                        onPaste={(e) => handlePasteQuestions(e, index)}
                        style={{
                          width: "100%",
                          padding: "6px",
                          border: "1px solid #ccc",
                          borderRadius: "6px",
                          color: "#000",
                          background: "#fff",
                        }}
                      />
                    </td>

                    {/* TYPE */}
                    <td>
                      <select
                        value={item.QUESTION_TYPE || "Rating"}
                        onChange={(e) =>
                          handleTypeChange(index, e.target.value)
                        }
                        style={{
                          width: "100%",
                          padding: "6px",
                          borderRadius: "6px",
                          border: "1px solid #ccc",
                        }}
                      >
                        <option value="Rating">Rating</option>
                        <option value="Dropdown">Dropdown</option>
                      </select>
                    </td>

                    {/* STATUS */}
                    <td>
                      <label className="switch">
                        <input
                          type="checkbox"
                          checked={item.STATUS === "ACTIVE"}
                          onChange={() => handleStatusToggleQuestion(index)}
                        />
                        <span className="slider"></span>
                      </label>
                    </td>

                    {/* DELETE ONLY */}
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="fa-solid fa-trash fa-lg edit-icon"
                        title="Delete"
                        onClick={() => handleDeleteRow(index)}
                      ></i>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* FOOTER BUTTONS */}
          <div className="popup-buttons">
            <button className="btn-save" onClick={handleAddQuestionRow}>
              + Add Question
            </button>

            <button className="btn-save" onClick={handleSaveQuestions}>
              Save
            </button>
          </div>
        </div>
      )}
    </>
  );
}
